import React, { useState } from 'react';
import { theme, Typography } from 'antd';
import { useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import LibraryLayout from 'components/Layouts/LibraryLayout';
import { RootState } from 'store/configureStore';
import { reportTypes } from 'constants/workingAreas';
import * as Styled from './LibraryReporting.styled';

const { useToken } = theme;
const { Text } = Typography;

const LibraryReporting: React.FC = () => {
  const { token } = useToken();
  const [downloadCount, setDownloadCount] = useState(0);

  const { scheme } = useSelector((state: RootState) => ({
    scheme: state.global.scheme
  }));

  const generateExcelData = () => {
    const data = [
      ['Column 1', 'Column 2', 'Column 3'],
      ['data for col. 1 ', 'data for col. 1', 'john@data for col. 1'],
      ['data for col. 2 ', 'data for col. 2', 'john@data for col. 2']
    ];

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    return wb;
  };

  const handleDownloadExcel = (filename: string) => {
    const wb = generateExcelData();
    XLSX.writeFile(wb, `${filename}.xlsx`);
    setDownloadCount((prev) => prev + 1);
  };

  return (
    <LibraryLayout>
      <Styled.Container token={token} scheme={scheme}>
        <Styled.SubHeaderSection token={token} scheme={scheme}>
          <h2>Library - Reporting</h2>
          <p>Generate and download comprehensive reports</p>
        </Styled.SubHeaderSection>

        <Styled.ContentRow gutter={[24, 24]}>
          <Styled.MainCol xs={24} lg={10}>
            <Styled.ReportsTitle level={4}>
              Generate Reports
            </Styled.ReportsTitle>
            <Styled.ReportsGrid token={token} scheme={scheme}>
              {reportTypes.map((report, index) => (
                <Styled.ReportCol key={index}>
                  <Styled.ReportCard
                    token={token}
                    scheme={scheme}
                    onClick={() => handleDownloadExcel(report.filename)}
                  >
                    <Styled.CardHeader></Styled.CardHeader>
                    <Styled.CardTitle token={token} level={5}>
                      {report.title}
                    </Styled.CardTitle>
                  </Styled.ReportCard>
                </Styled.ReportCol>
              ))}
            </Styled.ReportsGrid>
          </Styled.MainCol>
        </Styled.ContentRow>
      </Styled.Container>
    </LibraryLayout>
  );
};

export default LibraryReporting;
